import React, { Component } from "react";
import img from "../img/Final.svg";
import {
  Navbar,
  Container,
} from "reactstrap";
import "../css/header.css";

export default class Header extends Component {
  render() {
    return (
      <div>
        <Navbar color="light" className="main-screen" expand="md" dark>
          <Container>
            <img src={img} height="55" width="70" />
          </Container>
        </Navbar>
      </div>
    );
  }
}
